module.exports = __webpack_public_path__ + "static/media/l.330f93ff.png";